// extracted by mini-css-extract-plugin
module.exports = {"switcher":"Switch_switcher__2AAiu","label":"Switch_label__YZo3N","checkbox":"Switch_checkbox__2XIt4"};